import {gsap} from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import {breakpointDown, getScreenHeight, pxToRem, pxToScreenSize} from '../utils/breakpoints'

gsap.registerPlugin(ScrollTrigger)
let ourExperienceTl1 = []
let ourExperienceTl2 = []
window.initOurExperienceAnimations = () => {

  const blocks = document.querySelectorAll('[data-animate="rotate-in"]')

  if (!blocks) return false

  const clearExperience = (index) => {
    if (ourExperienceTl1[index]) {
      ScrollTrigger.getById(`experienceTrigger1${index}`).kill(true);
      gsap.set(blocks[index].querySelector('#img-trigger'), {clearProps: true});
      ourExperienceTl1[index].kill(true);
      ourExperienceTl1[index] = null;
    }
    if (ourExperienceTl2[index]) {
      ScrollTrigger.getById(`experienceTrigger2${index}`).kill(true);
      gsap.set(blocks[index].querySelector('.block-footer-container'), {clearProps: true});
      ourExperienceTl2[index].kill(true);
      ourExperienceTl2[index] = null;

    }

    const block = blocks[index];
    const components = block.querySelectorAll('.bg-image-1, .bg-image-2, .bg-image-3, .block-footer-container');
    components.forEach(component => {
      component.style.transition = 'none';
      component.style.transform = 'none';
      // Reset any other styles you want
    });
  }

  blocks.forEach((block, index) => {
    if ($(window).width() > 991) {
      clearExperience(index);
      const trigger = block.querySelector('#img-trigger')
      const c_height = pxToScreenSize(300) //getScreenHeight() - content.clientHeight

      ourExperienceTl1[index] = gsap.timeline({
        scrollTrigger: {
          id: `experienceTrigger1${index}`,
          trigger: trigger,
          pin: true,
          // markers: true,
          scrub: true,
          start: `center-=100px center`,
          end: 'bottom-=25% top',
        }
      })

      const img1 = block.querySelector('.bg-image-1')
      const img2 = block.querySelector('.bg-image-2')
      const img3 = block.querySelector('.bg-image-3')

      // tl.fromTo(contentText, {  y: 0 }, { y: '-100vh', duration: 0.7 }, 0)
      // tl.fromTo(contentText, {  opacity: 1 }, { opacity: 0, duration: 1 }, 0)
      // tl.fromTo(trigger, { y: 0 }, {y: '-65vh', duration: 0.4 }, 0)
      // tl.fromTo(img1, { y: '130%', rotate: 0 }, { y: 0, rotate: -4, duration: 1 })
      ourExperienceTl1[index].fromTo(img2, {y: '130%', rotate: 0}, {y: 0, rotate: 4, duration: 1})
      ourExperienceTl1[index].fromTo(img3, {y: '130%', rotate: -4}, {y: 0, rotate: 0, duration: 1})


      const footer = block.querySelector('.block-footer-container')

      ourExperienceTl2[index] = gsap.timeline({
        scrollTrigger: {
          id: `experienceTrigger2${index}`,
          trigger: footer,
          start: 'top+=50% center',
          end: 'top+=75% center',
          scrub: true,
          //markers: true
        }
      })

      ourExperienceTl2[index].fromTo(footer, {alpha: 0}, {alpha: 1, duration: 1})

    } else {
      clearExperience(index);
    }
  })


}


initOurExperienceAnimations()
